import { Link } from "react-router-dom";
import React from "react";
import "./LeftRight.scss";
export default function LeftRight(props) {
  return (
    <div className={`left-right ${props.styles ? props.styles : ""}`}>
      <div
        className="left"
        style={{ backgroundImage: `url(${props.img})` }}
        data-aos="fade-down"
        data-aos-duration="800"
        data-aos-easing="ease-out-cubic"
      ></div>
      <div
        className="right"
        data-aos="fade-up"
        data-aos-duration="800"
        data-aos-easing="ease-out-cubic"
      >
        <h3 className="subtitle">{props.subtitle}</h3>
        <h2 className="title">{props.title}</h2>
        {props.description ? (
          <p className="description">{props.description}</p>
        ) : null}
        {props.link ? <Link to={props.to}>{props.link}</Link> : null}
      </div>
    </div>
  );
}
